module.exports = __webpack_public_path__ + "img/slide-5-content.18900556.png";